var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.viewComponent,{tag:"component",attrs:{"msg":_vm.errorMessage,"uniqueID":_vm.uniqueID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }